export default __webpack_public_path__ + "static/media/img19.fd532039.svg";